import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const RoleSchema = z.object({
  id: z.number(),
  name: z.string(),
  userCount: z.number(),
});

const _GetRolesRequestDtoSchema = z.object({});

const GetRolesResponseDtoSchema = z.array(RoleSchema);

export type GetRolesRequestDto = z.infer<typeof _GetRolesRequestDtoSchema>;
export type GetRolesResponseDto = z.infer<typeof GetRolesResponseDtoSchema>;

export const getRoles = (config?: AxiosRequestConfig<GetRolesRequestDto>) => {
  return api
    .get('/roles', config)
    .then(responseContract(GetRolesResponseDtoSchema));
};
